import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { HowItWorks } from "@/components/HowItWorks";
import { EventTypes } from "@/components/EventTypes";
import { MenuHighlights } from "@/components/MenuHighlights";
import { About } from "@/components/About";
import { FAQ } from "@/components/FAQ";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <EventTypes />
        <MenuHighlights />
        <About />
        <FAQ />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
